
import { useSubscriptionStatus } from './useSubscriptionStatus';
import { useSubscriptionPayment } from './useSubscriptionPayment';
import { usePaymentStatus } from './usePaymentStatus';
import { /* PriceType, */ pricingConfig /* , PricingConfigType */ } from './types';

// Export new unified product discovery hooks
export {
  useUnifiedProductDiscovery,
  useProductsByInterval,
  useProductAvailability
} from './useUnifiedProductDiscovery';

// Export payment routing hook
export { usePaymentRouting } from './usePaymentRouting';

export type { PriceType, SubscriptionStatus, PricingConfigType } from './types';
export { pricingConfig };

export const useSubscription = () => {
  const {
    isSubscribed,
    isLoading,
    hasError,
    errorMessage,
    checkAttempted,
    isRefreshing,
    refreshStatus,
    source
  } = useSubscriptionStatus();

  const {
    upgradeInProgress,
    initiateSubscription
  } = useSubscriptionPayment();

  // Check for payment status in URL query parameters
  usePaymentStatus(refreshStatus);

  return {
    isSubscribed,
    isLoading,
    hasError,
    errorMessage,
    upgradeInProgress,
    initiateSubscription,
    refreshStatus,
    checkAttempted,
    isRefreshing,
    subscriptionSource: source,
    pricingConfig // Add the pricingConfig to the returned object
  };
};
